export const topOptions = {
    responsive: true,
    scales: {
        y: {
            stacked: true,
        },
    },
    plugins: {
        filler: {
            propagate: false,
        },
        'samples-filler-analyser': {
            target: 'chart-analyser',
        },
    },
    interaction: {
        intersect: false,
    },
};
